import React from 'react';
import styled from 'styled-components';
import { Type } from '@spotify-internal/encore-web';
import { ONE_COLUMN_MAX_WIDTH } from './Grid';
const TabletVariant = styled(Type) `
  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    display: none;
  }
`;
const PhoneVariant = styled(Type) `
  display: none;
  @media (max-width: ${ONE_COLUMN_MAX_WIDTH}) {
    display: block;
  }
`;
export const MobileResponsiveType = ({ as, variantTablet, variantPhone, className, children }) => {
    return (React.createElement("div", { className: className },
        React.createElement(TabletVariant, { as: as, variant: variantTablet }, children),
        React.createElement(PhoneVariant, { as: as, variant: variantPhone }, children)));
};
//# sourceMappingURL=MobileResponsiveType.js.map